import { SxProps, Theme } from "@mui/material";
import { assessmentPhoneLandscapeMedia, assessmentTabletLandscapeMedia, assessmentShortViewportMedia } from "../assessment-layout-styles";

export const containerStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: { xs: 1, md: 2 },
  flexWrap: "wrap",
  mb: { xs: 0, md: 2 },
  [assessmentPhoneLandscapeMedia]: {
    mb: 2,
  },
  [assessmentTabletLandscapeMedia]: {
    mb: 0,
  },
};

export const titleStyle: SxProps<Theme> = (theme) => ({
  fontSize: "22px",
  fontWeight: 700,
  color: theme.palette.quizPopap.quizText,
  [assessmentShortViewportMedia]: {
    fontSize: "16px",
    lineHeight: 1.2,
  },
});

export const titleBlockStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 0.25,
  minWidth: 0,
  flex: "1 1 auto",
  maxWidth: "100%",
};

export const contestTitleStyle: SxProps<Theme> = (theme) => ({
  fontSize: { xs: "13px", sm: "14px" },
  fontWeight: 500,
  lineHeight: 1.3,
  color: theme.palette.quizPopap.quizText,
  opacity: 0.72,
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  [assessmentShortViewportMedia]: {
    fontSize: "12px",
  },
});

export const rightSideStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: { xs: 0.75, sm: 1 },
  flexWrap: { xs: "nowrap", sm: "wrap" },
  flexShrink: 0,
  maxWidth: "100%",
  overflowX: { xs: "auto", sm: "visible" },
};

export const rankChipStyle = (theme: Theme): SxProps<Theme> => ({
  borderRadius: "999px",
  flexShrink: 0,
  px: 0.25,
  height: { xs: 28, sm: 32 },
  fontSize: { xs: "12px", sm: "13px" },
  backgroundColor: theme.palette.mode === "dark" ? "#2A2F3A" : "#F5F3FF",
  color: theme.palette.quizPopap.quizText,
  border: `1px solid ${theme.palette.quizPopap.quizSeparator}`,
  fontWeight: 700,
  "& .MuiChip-icon": {
    color: "#8B5CF6",
  },
  [assessmentShortViewportMedia]: {
    height: 24,
    fontSize: "11px",
  },
});
